import React, {useState, useRef, useEffect} from 'react';
import {showToast} from '../../../../Component/Toast';
import {encryptPassword} from '../../../../Utils/Crypto'
import {useHistory} from 'react-router-dom'
import Spinner from '../../../../Component/Loader'
import Button from '../../../../Component/Button'
import useClientHook from "../../../../Hooks/useClientHook";
import RecaptchaV3 from '../../../../Component/RecaptchaV3'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import useEmployeeHook from "../../useEmployeeHook";
import Axios from 'axios';
function Index() {

	const HISTORY = useHistory();
	const [Loader, setLoader] = useState(undefined);
	const [Recaptcha, setRecaptcha] = useState(undefined);
	const [mode, setMode] = useState(undefined);
	const [btnLoader, setBtnLoader] = useState(false);
	const URLS = useEmployeeHook()


	let TenantId = useRef(null), EmpCode = useRef(null), Password = useRef();
	const [LoginMessage, setLoginMessage] = useState();
	let params = new URLSearchParams(window.location.search)
	let {client_id, origin, logo, provider} = useClientHook('LOGIN')
	let hiddenLogin = params.get('hidden_login') === 'true'

	useEffect(() => {

		if (params.get('success') === 'false') {
			if (params.get('type')) {
				if (params.get('type') === 'mobile') {
					HISTORY.push(`/mobile?prefill=${params.get('prefill')}&message=${params.get('message')}&origin=${origin}&provider=${provider}`)
				}
				if (params.get('type') === 'code' && TenantId.current && EmpCode.current) {
					let IDs = params.get('prefill').split('|');
					TenantId.current.value = IDs[0]
					EmpCode.current.value = IDs[1]
				}
			}
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}

	}, [HISTORY, params, client_id, origin, provider]);

	const checkSSO = () => {
		let tenant = TenantId.current.value;
		let emp = EmpCode.current.value;

		if (!Recaptcha) {
			showToast({type: 'error', message: 'Please validate captcha'})
			return;
		}

		if (!tenant || !emp) {
			showToast({type: 'error', message: "Enter both Client Code and Emp Code"})
			return
		}

		setBtnLoader(true)
		Axios.post(URLS?.code || 'https://fedgo.dev.eka.io/provider-uat/auth/employee/code', {
			employeeCode: emp,
			companyCode: tenant,
			client_id,
			origin: provider
		}).then(res => {
			setBtnLoader(false)
			if (res.data.sso && res.data.ssoUrl) {
				window.location.href = res.data.ssoUrl
			} else {
				setMode('PASSWORD')
			}
		}).catch(err => {
			setBtnLoader(false)
			if (err.response) {
				showToast({type: 'error', message: err.response.data.message})
			} else if (err.request) {
				let msg = JSON.parse(err.request.response)
				showToast({type: 'error', message: msg.message})
			}
		})
	}

	const submitForm = e => {

		let tenant = TenantId.current.value;
		let emp = EmpCode.current.value;
		let pass = Password.current.value;

		if (!Recaptcha) {
			showToast({
				type: 'error',
				message: 'Please validate captcha'
			})
			return;
		}

		if (!tenant || !emp) {
			showToast({
				type: 'error',
				message: "Enter both Client Code and Emp Code"
			})
			return
		}

		if (!pass) {
			showToast({
				type: 'error',
				message: "Please enter Password"
			})
			return
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = URLS?.login||"https://auth.dice.tech/auth/employee/email";

		let params = {
			username: `${tenant}|${emp}`,
			password: encryptPassword(`${tenant}|${emp}`, pass),
			referrer: window.location.origin,
			...(client_id ? {client_id: client_id} : undefined),
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		try {
			setLoader(true)
			form.submit();
		} catch (err) {
			setLoader(undefined)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went wrong !"
			})
		}

	}

	const ResetPass = (params) => {
		HISTORY.push(`/reset?type=code&id=${TenantId.current.value}&code=${EmpCode.current.value}&origin=${origin}&provider=${provider}`)
	}


	if (Loader || !client_id) {
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center'
					style={{background: '#fff'}}><Spinner/></div>
	}


	return (
		<>
			<div className="container" style={{height: '100vh'}}>
				<div className="row justify-content-center h-100-center">
					<div className="col-md-6 pt-4">
						<div className="p-3" style={{
							backgroundColor: '#fff',
							borderRadius: '1rem',
							maxWidth: 400,
							boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important',
							margin: 'auto'
						}}>
							{["JKCUAT","JKCPROD"].includes(provider)?null:<img className="img-fluid mb-4" src={logo} alt='Lock' style={{maxHeight: 60}}/>}
							<h1 className="display-6 fw-bold mb-0">Code Log in</h1>
							<p>Enter your Company code and Employee code</p>

							<div className="mt-4 mb-4">
								<div>
									<div className='d-flex mb-2'>
										<div className=" me-2">
											<p className="label">
												Client Code
											</p>
											<input ref={TenantId} type="text" className="form-control"
												   placeholder="Client Code"/>
										</div>
										<div>
											<p className="label">
												Employee Code
											</p>
											<input ref={EmpCode} type="text" className="form-control"
												   placeholder="Employee Code"/>
										</div>
									</div>
									{(provider !== 'FEDERALUAT' || hiddenLogin || mode === 'PASSWORD') && <>
									<p className="label">
										Password
									</p>
									<input ref={Password} type="password" className="form-control mb-2"
										   placeholder="Password"/>
									{
										LoginMessage ?
											<p className='text-danger text-left'
											   style={{fontSize: '0.8rem', textAlign: 'left'}}>
												<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em"
													 height="1em" fill="currentColor" viewBox="0 0 16 16">
													<path
														d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
												</svg>
												{LoginMessage}
											</p>
											: <></>
									}
									<div className='text-start mb-3 text-primary'
										 style={{fontSize: '0.9rem', cursor: 'pointer'}} onClick={ResetPass}>Forgot
										Password ?
									</div>
								</>}
								<GoogleReCaptchaProvider reCaptchaKey="6LdONk0kAAAAAM3aVQuxbR76xPD6w4NLr35Ir8eF">
									<RecaptchaV3 onToken={setRecaptcha}/>
								</GoogleReCaptchaProvider>
								{(provider === 'FEDERALUAT' && !hiddenLogin)
									? mode === 'PASSWORD'
										? <Button onClick={submitForm} name='Log in' loading={Loader}/>
										: <Button onClick={checkSSO} name='Next' loading={btnLoader}/>
									: <Button onClick={submitForm} name='Log in' loading={Loader}/>
								}
								</div>
							</div>

							<p className="text-start" style={{fontSize: '0.9rem'}}>
								<span>Login using&nbsp;&nbsp;&nbsp;</span>
								<a className="text-primary"
								   href={`/?origin=${origin}&provider=${provider}`}>Email</a>&nbsp;&nbsp;
								{(['JKCUAT','JKCPROD'].includes(provider))?null:<>
								<a className="text-dark" href="/">|</a>&nbsp;&nbsp;
								<a className="text-primary"
								   href={`/mobile?origin=${origin}&provider=${provider}`}>Mobile</a>
								</>}
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Index;
